import { Card, IconButton, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import { useEffect, useState } from 'react';
import styles from './banner.module.scss';
import { useFileUploadContext } from '../../../context/fileUploadContext';
import { ButtonV3 } from 'gf-ui-components-mui-lib';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTableContext } from '../../../context/tableContext';

export const FileUploadStatus = ({
  imageIcon,
  status,
  displayMessage,
}: {
  imageIcon?: string;
  status?: string;
  displayMessage?: any;
}) => {
  const theme = useTheme();
  const {
    setSuccessWindow,
    setFailedWindow,
    setErrorWindow,
    errorWindow,
    successWindow,
    failedWindow,
    setUploadView,
  } = useFileUploadContext();

  const { renderRecords } = useTableContext();

  const closeWindow = () => {
    if (successWindow?.status) {
      setSuccessWindow({
        status: false,
        message: '',
        uploadScreen: '',
      });
    }

    if (failedWindow?.status) {
      setFailedWindow({
        status: false,
        message: '',
        uploadScreen: '',
      });
    }

    if (errorWindow?.status) {
      setErrorWindow({
        status: false,
        message: '',
      });
    }

    renderRecords();
  };

  const startUpload = () => {
    setUploadView(failedWindow?.uploadScreen);

    setFailedWindow({
      ...failedWindow,
      status: false,
      message: '',
    });
  };

  const [progress, setProgress] = useState(200);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress === 20 ? 0 : prevProgress - 20
      );
    }, 200);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Card
      sx={{
        position: 'absolute',
        zIndex: 100,
        right: '0.9%',
        top: '9.8%',
        minWidth: '343px',
        maxWidth: '600px',
        borderRadius: '8px',
        border: failedWindow?.status
          ? '1px solid #F04248'
          : errorWindow?.status
          ? '1px solid #FFD21E'
          : '1px solid #00DF80',
        [theme.breakpoints.down(1441)]: {
          minWidth: '250px',
          maxWidth: '300px',
          top: '2.8%',
        },
      }}
    >
      <div className={`${styles.main}`}>
        <div className={`${styles.iconContainer}`}>
          <img src={imageIcon} alt='' />
          {errorWindow?.status ? null : (
            <div style={{ display: 'flex', width: '200px' }}>
              <div className={`${styles.progressBarChild}`}>
                <LinearProgress
                  variant='determinate'
                  value={progress}
                  sx={{
                    height: '100%',
                    borderRadius: '4px',
                    background: '#FFFFFF',
                  }}
                />
              </div>
            </div>
          )}
          <IconButton onClick={closeWindow}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={`${styles.successContainer}`}>
          <p className={`${styles.success}`}>{status}</p>
          <p className={`${styles.uploadMessage}`}>{displayMessage}</p>
        </div>
      </div>
      {!failedWindow?.status && failedWindow?.message && (
        <div className={`${styles.buttonContainer}`}>
          <ButtonV3
            variant='text'
            endIcon={
              <ArrowForwardIcon sx={{ color: 'var(--primary-500, #2469F3)' }} />
            }
            sx={{
              border: 'none',
              background: 'transparent',
              boxShadow: 'none',
              padding: 0,
              color: 'var(--primary-500, #2469F3)',
              fontFamily: 'Poppins',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
            }}
            onClick={startUpload}
          >
            Upload Again
          </ButtonV3>
        </div>
      )}
    </Card>
  );
};
